import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import Content from '../../../components/Pages/Admins/Create';

const { displayName } = config;

export default function AdminCreate(): React.ReactNode | null {
  document.title = `${displayName}: Admin create`;

  return (
    <Layout
      title="Admin create"
    >
      <Content />
    </Layout>
  );
}
